// Chakra Imports
import {
  Avatar,
  Flex,
  Icon,
  Menu,
  MenuButton,
  MenuItem,
  MenuList,
  Text,
  useColorModeValue,
  useColorMode,
  Box,
  Tag,
  TagLabel,
} from '@chakra-ui/react';
// Custom Components
import { SidebarResponsive } from 'components/sidebar/Sidebar';
import PropTypes from 'prop-types';
import React from 'react';
// Assets
import { FaEthereum } from 'react-icons/fa';
import routes from 'routes';
import { useNavigate } from 'react-router-dom';
import AppMenu from 'components/app-menu/AppMenu';
import { toProperCase } from 'utils/formatting';
export default function HeaderLinks(props) {
  const { secondary, } = props;
  // Chakra Color Mode
  let menuBg = useColorModeValue('white', 'navy.800');
  const textColor = useColorModeValue('secondaryGray.900', 'white');
  const ethColor = useColorModeValue('gray.700', 'white');
  const borderColor = useColorModeValue('#E6ECFA', 'rgba(135, 140, 189, 0.3)');
  const ethBg = useColorModeValue('secondaryGray.300', 'navy.900');
  const ethBox = useColorModeValue('white', 'navy.800');
  const shadow = useColorModeValue(
    '14px 17px 40px 4px rgba(112, 144, 176, 0.18)',
    '14px 17px 40px 4px rgba(112, 144, 176, 0.06)',
  );
  const user = JSON.parse(localStorage.getItem('user_profile'));
  const userName = user?.first_name && user?.last_name ? `${user?.first_name} ${user?.last_name}` : null;
  const userRole = user?.user_role;

  const navigate = useNavigate()
  const handleLogout = () => {
    localStorage.removeItem('access_token');
    localStorage.removeItem('user_profile');
    localStorage.removeItem('user_role');
    navigate("/auth/sign-in")
  }

  const roleColors = {
    admin: { bg: "red.100", color: "red.800" },
    superadmin: { bg: "purple.100", color: "purple.800" },
    staff: { bg: "blue.100", color: "blue.800" },
    provider: { bg: "green.100", color: "green.800" },
    subscriber: { bg: "orange.100", color: "orange.800" },
    default: { bg: "gray.100", color: "gray.800" },
  };

  const { bg, color } = roleColors[userRole?.toLowerCase()] || roleColors.default;


  return (
    <Flex
      w={{ sm: '100%', md: 'auto' }}
      alignItems="center"
      flexDirection="row"
      bg={menuBg}
      flexWrap={secondary ? { base: 'wrap', md: 'nowrap' } : 'unset'}
      p="10px"
      borderRadius="30px"
      boxShadow={shadow}
      zIndex={10}
    >
      <Box
        display={{ base: 'flex', md: 'none', }}
        mr="auto"
      >
        <AppMenu />
      </Box>
      <Flex
        bg={ethBg}
        display={secondary ? 'flex' : 'none'}
        borderRadius="30px"
        ms="auto"
        p="6px"
        align="center"
        me="6px"
      >
        <Flex
          align="center"
          justify="center"
          bg={ethBox}
          h="29px"
          w="29px"
          borderRadius="30px"
          me="7px"
        >
          <Icon color={ethColor} w="9px" h="14px" as={FaEthereum} />
        </Flex>
        <Text
          w="max-content"
          color={ethColor}
          fontSize="sm"
          fontWeight="700"
          me="6px"
        >
          1,924
          <Text as="span" display={{ base: 'none', md: 'unset' }}>
            {' '}
            ETH
          </Text>
        </Text>
      </Flex>
      <SidebarResponsive routes={routes} />
      <Menu>
        <MenuButton p="0px">
          <Avatar
            _hover={{ cursor: 'pointer' }}
            color="white"
            name={userName || "Admin"}
            bg="#11047A"
            size="sm"
            w="40px"
            h="40px"
          />
        </MenuButton>
        <MenuList
          boxShadow={shadow}
          p="0px"
          mt="10px"
          borderRadius="20px"
          bg={menuBg}
          border="none"
        >
          <Flex w="100%" mb="0px">
            <Text
              px="20px"
              pt="16px"
              pb="10px"
              w="100%"
              display="flex"
              alignItems="center"
              borderBottom="1px solid"
              borderColor={borderColor}
              fontSize="sm"
              fontWeight="700"
              color={textColor}
              justifyContent="space-between"
            >
              {toProperCase(userName) || "Admin"}
              <Tag
                size="sm"
                borderRadius="full"
                px={2}
                py={1}
                bg={bg}
                color={color}
                fontWeight="600"
                ml="auto"
                display="inline-block"
              >
                <TagLabel textTransform="capitalize">{userRole}</TagLabel>
              </Tag>
            </Text>
          </Flex>
          <Flex flexDirection="column" p="10px">
            <MenuItem
              _hover={{ bg: 'none', color: "brand.500" }}
              _focus={{ bg: 'none', color: "brand.500" }}
              borderRadius="8px"
              px="14px"
              onClick={() => navigate("/admin/profile-settings")}
            >
              <Text fontSize="sm">Profile Settings</Text>
            </MenuItem>
            <MenuItem
              _hover={{ bg: 'none', color: "brand.500" }}
              _focus={{ bg: 'none', color: "brand.500" }}
              borderRadius="8px"
              px="14px"
              onClick={() => navigate("/admin/account-settings")}
            >
              <Text fontSize="sm">Account Settings</Text>
            </MenuItem>

            <MenuItem
              _hover={{ bg: 'none', color: "red.700" }}
              _focus={{ bg: 'none', color: "red.700" }}
              color="red.400"
              fontWeight="bold"
              borderRadius="8px"
              px="14px"
              onClick={handleLogout}
            >
              <Text fontSize="sm">Log out</Text>
            </MenuItem>
          </Flex>
        </MenuList>
      </Menu>
    </Flex>
  );
}

HeaderLinks.propTypes = {
  variant: PropTypes.string,
  fixed: PropTypes.bool,
  secondary: PropTypes.bool,
  onOpen: PropTypes.func,
};
